import { render, staticRenderFns } from "./EditEditorTextModal.vue?vue&type=template&id=f0814c8a&scoped=true"
import script from "./EditEditorTextModal.vue?vue&type=script&lang=js"
export * from "./EditEditorTextModal.vue?vue&type=script&lang=js"
import style0 from "./EditEditorTextModal.vue?vue&type=style&index=0&id=f0814c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0814c8a",
  null
  
)

export default component.exports